<template>
    <project-step-container
            prev-to="go_broad_to_go_narrow_10"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                {{getMessage(11, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(11, 'firstIdea')}}</label>
                <textarea id="first-thing" type="text" v-model="form.firstIdea" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(11, 'secondIdea')}}</label>
                <textarea id="second-thing" type="text" v-model="form.secondIdea" rows="3"></textarea>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(11, 'thirdIdea')}}</label>
                <textarea id="third-thing" type="text" v-model="form.thirdIdea" rows="3"></textarea>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "GoBroadToGoNarrow11",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_TOP_IDEAS,
                urlNextProject:'go_broad_to_go_narrow_12',
                form: {
                    firstIdea: "",
                    secondIdea: "",
                    thirdIdea: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection();
                    }
                }).catch(err => {
                    this.redirection();
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

